import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import * as Layout from '../../common/styles/Layout';
import { classNames } from '../../common/styles/Utils';
import { imgPath } from '../../common/utils/ImgUrl';
import { EmptyStateStyle, EmptyStateSubTitleStyle, EmptyStateTitleStyle } from '../styles/SearchResultPageStyles';

export function OopsPage(): JSX.Element {
  return (
    <div aria-live="polite" role="status" className={classNames(EmptyStateStyle, Layout.absolute, Layout.center)}>
      <img src={imgPath('spaces_empty_search.svg')} alt={''} />
      <div className={EmptyStateTitleStyle}>{Messages.OopsHeader()}</div>
      <div className={EmptyStateSubTitleStyle}>{Messages.OopsMessage()}</div>
    </div>
  );
}
